module.exports = __webpack_public_path__ + "img/stretch--genre4_tab-icon.6f2fa6af.png";